export default __webpack_public_path__ + "static/media/supervillain_medium-light-skin-tone_1f9b9-1f3fc_1f3fc.0ae7e0e9.png";